import Pill from './Pill';

export type { PillProps } from './Pill';
export default Pill;
